import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { NOTAM } from '../models/notam.model';


@Component({
  selector: 'app-tfr-details',
  templateUrl: './tfr-details.component.html',
  styleUrls: ['./tfr-details.component.scss']
})
export class TfrDetailsComponent implements OnInit {
  tfr: NOTAM;

  constructor(private _matDialogRef: MatDialogRef<TfrDetailsComponent>,
              @Inject(MAT_DIALOG_DATA) data) {
    this.tfr = data.tfr;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
  }

  close(data: any) {
    this._matDialogRef.close(data);
  }

  cancel () {
    this.close({cancelBtnClicked: true});
  }
}
